import { render, staticRenderFns } from "./productSpecification.vue?vue&type=template&id=0c49e1fe"
import script from "./productSpecification.vue?vue&type=script&lang=js"
export * from "./productSpecification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports